import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=3e4c8884&scoped=true&"
import script from "./TemplatesList.vue?vue&type=script&lang=js&"
export * from "./TemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=3e4c8884&scoped=true&lang=scss&"
import style1 from "./TemplatesList.vue?vue&type=style&index=1&id=3e4c8884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4c8884",
  null
  
)

export default component.exports